// @flow
import { HIDE_MOBILE_MENU, TOGGLE_MOBILE_MENU } from './constants';

import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

const initialState = {
    isMobileMenuShown: false
};

const actionHandlers = {
    [HIDE_MOBILE_MENU]: handleReduce(() => ({ isMobileMenuShown: false })),
    [TOGGLE_MOBILE_MENU]: handleReduce(state => ({
        isMobileMenuShown: !state.isMobileMenuShown
    }))
};

export default handleActions(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/core/state/menu/index.js